<template>
  <div
      class=" w-fit p-1 shadow-lg my-4 rounded-md text-left outline outline-1 outline-gray-500 "
      :class="{'opacity-50': url.length === 0,
              'cursor-pointer hover:outline-gray-300': url.length > 0}"
      @click="() => handleGoogle()"
      >

      <div >
          <div class="font-bold">
              <span>
                  <img src="https://1000logos.net/wp-content/uploads/2016/11/New-Google-Logo.jpg" class="rounded-sm w-8 h-8"/>
              </span>
              Connectez votre compte Google
          </div>
          <div class="m-1 font-light">
              Connectez un compte Google pour accéder aux connecteurs.
          </div>
      </div>
</div>

</template>

<script setup>
import { ref } from "vue";
import google_service from "../../services/google.js";

var popup = null;

let url = ref("");

const initGoogle = async () => {
  let scopes = "openid";
  scopes += " email";
  scopes += " profile";
  scopes += " https://www.googleapis.com/auth/drive";
  scopes += " https://www.googleapis.com/auth/drive.file";
  scopes += " https://www.googleapis.com/auth/drive.readonly";
  scopes += " https://www.googleapis.com/auth/spreadsheets";
  scopes += " https://www.googleapis.com/auth/spreadsheets.readonly";

  // ask backend for url
  let res = await google_service.get_auth_url(scopes);

  console.log("Got URL: ", res.auth_url);

  url.value = res.auth_url;
  // url.value = res.auth_url;
}

const handleGoogle = () => {
  if (url.value.length == 0) {
      return;
  }

  // window.removeEventListener("message", receiveGoogle);
  popup = window.open(
      url.value,
      "googleOAauthWindow",
      "width=500, height=750, left=20, top=20"
  );
  if (popup == null) {
      return;
  }
  popup.focus();
}

initGoogle();


</script>